/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Pages_ReadInputs */

const en_directory_agent_readiness_pages_read = /** @type {(inputs: Directory_Agent_Readiness_Pages_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages read`)
};

const zh_directory_agent_readiness_pages_read = /** @type {(inputs: Directory_Agent_Readiness_Pages_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取页面`)
};

/**
* | output |
* | --- |
* | "Pages read" |
*
* @param {Directory_Agent_Readiness_Pages_ReadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_pages_read = /** @type {((inputs?: Directory_Agent_Readiness_Pages_ReadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Pages_ReadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_pages_read(inputs)
	return zh_directory_agent_readiness_pages_read(inputs)
});
export { directory_agent_readiness_pages_read as "directory.agent_readiness.pages_read" }